
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pintar-score",
      function () {
        return require("private-next-pages/pintar-score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pintar-score"])
      });
    }
  